import { render, staticRenderFns } from "./private-comment.vue?vue&type=template&id=47f24616"
import script from "./private-comment.vue?vue&type=script&lang=js"
export * from "./private-comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports